import { UPDATE_SALON_SERVICES, UPDATE_SALON_INFORMATION, UPDATE_BOOKING_SETTINGS } from '../constants';
import { QueryParams } from '../types/salon';
import { ServiceGroup } from '../types/service';
import BookingService from '../services/bookingService';

export const salonActions = {
  storeQueryParams(payload: QueryParams) {
    return {
      type: UPDATE_SALON_INFORMATION,
      payload,
    };
  },

  storeSalonServices(payload: ServiceGroup[]) {
    return {
      type: UPDATE_SALON_SERVICES,
      payload,
    };
  },

  storeBookingSettings(payload: any) {
    return {
      type: UPDATE_BOOKING_SETTINGS,
      payload,
    };
  },

  fetchSalonServices(salonId: number, stylistId?: number) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchSalonServices(salonId, stylistId);
    };
  },
};
